import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const PageContainer = styled.div`
  background-color: ${({ backgroundColor }) => backgroundColor};
  padding-bottom: 50px;
`;

const PaddingContainer = styled.div`
  width: auto;
  margin-left: auto;
  margin-right: auto;
  max-width: 1280px;
`;

function ContainerStyles({ children, backgroundColor }) {
  return (
    <PageContainer backgroundColor={backgroundColor}>
      <PaddingContainer>{children}</PaddingContainer>
    </PageContainer>
  );
}

ContainerStyles.propTypes = {
  children: PropTypes.node.isRequired,
  backgroundColor: PropTypes.string,
};

ContainerStyles.defaultProps = {
  backgroundColor: 'transparent',
};

export default ContainerStyles;
